var map = {
	"./en.json": [
		11072,
		"src_aurora_components_breadcrumb_i18n_en_json"
	],
	"./es.json": [
		19050,
		"src_aurora_components_breadcrumb_i18n_es_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8422;
module.exports = webpackAsyncContext;